import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import Moment from 'moment'
import ObjectAssignDeep from 'object-assign-deep'
// import router from './router'
Vue.use(Vuex)
Vue.use(VueResource)

const store = new Vuex.Store({
  state: {
    leftMenuVisible: false,
    mobMenuVisible: false,
    user: null,
    userForProfile: null,
    winW: 0,
    winH: 0,
    winScrollTop: 0,
    tktShare: {
      order: 0,
      tickets: []
    },
    tktQrOrder: null,
    tktQrIndex: 0,
    tktQrMovie: '',
    tktQrCinema: 0,
    support_visible: false,
    change_name_visible: false,
    show_qr_card_pp: false,
    cities: [],
    dicts: {},
    currentOrders: [],
    currentFilms: {},
    currentItems: {},
    cinemasById: {},
    historyOrders: [],
    historyFilms: {},
    historyItems: {},
    orderHistoryOffset: 0,
    noMoreOperations: false,
    uLang: '',
    badges: {
      'opens': {'ua': [], 'ru': [], 'def': []},
      'closed': {'ua': [], 'ru': [], 'def': []}
    },
    offers: {'ua': [], 'ru': [], 'def': []},
    qrCodeCardNumber: null,
    nextLvlRequirementsOpen: false,
    fillProfileOpen: false,
    currentBadge: null,
    friendsLevels: {'ua': [], 'ru': [], 'def': []}
  },
  mutations: {
    // задать язык интерфейса
    setLang: function (state, lang) {
      state.uLang = lang
    },
    // скрыть / показать затемнение
    showLeftMenu: function (state) {
      state.leftMenuVisible = true
    },
    hideLeftMenu: function (state) {
      state.leftMenuVisible = false
    },
    // задать инфо о юзере
    setUser: function (state, userData) {
      state.user = userData
      state.user.personal.birthday = state.user.personal.birthday === '' ? '' : Moment(state.user.personal.birthday).format('DD.MM.YYYY')
      state.user.family.forEach(function (elem) {
        elem.birthday = elem.birthday === '' ? '' : Moment(elem.birthday).format('DD.MM.YYYY')
      })
      state.userForProfile = ObjectAssignDeep({}, state.user)
    },
    resetUserToIriginal: function (state) {
      state.userForProfile = ObjectAssignDeep({}, state.user)
    },
    applyUserFromProfile: function (state) {
      state.user = ObjectAssignDeep({}, state.userForProfile)
      // state.user.personal.birthday = Moment(state.user.personal.birthday).format('DD.MM.YYYY')
      // state.user.family.forEach(function (elem) {
      //   elem.birthday = Moment(elem.birthday).format('DD.MM.YYYY')
      //   console.log(elem.birthday)
      // })
    },
    // Задать аватар юзера
    setUserAvatar: function (state, url) {
      state.user.avatar = url
    },
    // задать значение текущей ширины окна
    setWinW: function (state, winW) {
      state.winW = winW
    },
    // задать значение текущей высоты окна
    setWinH: function (state, winH) {
      state.winH = winH
    },
    // задать/сбросить массив билетов для шейра
    setTicketsForShare: function (state, tickets, order) {
      state.tktShare = {
        order: order,
        tickets: tickets
      }
    },
    resetTicketsForShare: function (state) {
      state.tktShare = {
        order: 0,
        tickets: []
      }
    },
    // задать/сбросить массив билетов для показа qr-кода
    setTktQrOrder: function (state, order) {
      state.tktQrOrder = order
    },
    resetTktQr: function (state) {
      state.tktQrOrder = null
      state.tktQrIndex = 0
      state.tktQrMovie = ''
    },
    // смена билета, на который смотрим qr-код
    incrementTktQr: function (state) {
      if (state.tktQrIndex >= state.tktQrOrder.items.length - 1) {
        state.tktQrIndex = 0
      } else {
        state.tktQrIndex++
      }
    },
    decrementTktQr: function (state) {
      if (state.tktQrIndex <= 0) {
        state.tktQrIndex = state.tktQrOrder.items.length - 1
      } else {
        state.tktQrIndex--
      }
    },
    // задать/сбросить тайтл попапа просмотра qr-кода
    setTktQrMovie: function (state, title) {
      state.tktQrMovie = title
    },
    resetTktQrMovie: function (state) {
      state.tktQrMovie = ''
    },
    // задать значение текущего скролла окна
    setWinScrollTop: function (state, scrollTop) {
      state.winScrollTop = scrollTop
    },
    // показать/скрыть саппорт
    showSupport: function (state) {
      state.support_visible = true
    },
    hideSupport: function (state) {
      state.support_visible = false
    },
    // показать/скрыть окно смены имени
    showChangeName: function (state) {
      state.change_name_visible = true
    },
    hideChangeName: function (state) {
      state.change_name_visible = false
    },
    showCardQr: function (state) {
      state.show_qr_card_pp = true
    },
    hideCardQr: function (state) {
      state.show_qr_card_pp = false
    },
    setCardQr: function (state, qrString) {
      state.qrCodeCardNumber = qrString
    },
    // обновить имя/фамилию юзера
    updateUserNames: function (state, unames) {
      state.user.personal.name = unames.name
      state.userForProfile.personal.name = unames.name
      state.user.personal.surname = unames.surname
      state.userForProfile.personal.surname = unames.surname
    },
    // сохранить города
    setCities: function (state, cities) {
      state.cities = cities
    },
    // показать/скрыть правое меню
    showMobMenu: function (state) {
      state.mobMenuVisible = true
    },
    hideMobMenu: function (state) {
      state.mobMenuVisible = false
    },
    // получить справочники
    setDicts: function (state, dicts) {
      state.dicts = dicts
    },
    // задать текущие заказы
    setCurrentOrders: function (state, currentOrders) {
      for (var i = 0; i < currentOrders.length; i++) {
        currentOrders[i].tickets = []
        currentOrders[i].bar = []
        currentOrders[i].dets_visible = false
        var operMmdt = Moment(currentOrders[i].date_time)
        currentOrders[i].operDateStr = operMmdt.format('DD.MM.YYYY')
        currentOrders[i].operTimeStr = operMmdt.format('HH:mm')
        for (var j = 0; j < currentOrders[i].items.length; j++) {
          var curItem = currentOrders[i].items[j]
          curItem.qty = Math.abs(curItem.qty)
          if (curItem.film) {
            currentOrders[i].tickets.push(curItem)
          } else {
            currentOrders[i].bar.push(curItem)
          }
        }
        var zeroTicket = currentOrders[i].tickets[0]
        var mmdt = Moment(zeroTicket.session_date_time)
        currentOrders[i].dateStr = mmdt.format('DD.MM.YYYY')
        currentOrders[i].timeStr = mmdt.format('HH:mm')
        currentOrders[i].film = zeroTicket.film
        currentOrders[i].screen_name = zeroTicket.screen_name
      }
      state.currentOrders = currentOrders
    },
    // задать текущие фильмы
    setCurrentFilms: function (state, currentFilms) {
      state.currentFilms = currentFilms
    },
    // задать текущие позиции бара
    setCurrentItems: function (state, currentItems) {
      state.currentItems = currentItems
    },
    // Задать историю заказов
    setHistoryOrders: function (state, historyOrders) {
      for (var i = 0; i < historyOrders.length; i++) {
        historyOrders[i].tickets = []
        historyOrders[i].bar = []
        historyOrders[i].dets_visible = false
        var operMmdt = Moment(historyOrders[i].date_time)
        historyOrders[i].operDateStr = operMmdt.format('DD.MM.YYYY')
        historyOrders[i].operTimeStr = operMmdt.format('HH:mm')
        for (var j = 0; j < historyOrders[i].items.length; j++) {
          var curItem = historyOrders[i].items[j]
          curItem.qty = Math.abs(curItem.qty)
          if (curItem.film) {
            historyOrders[i].tickets.push(curItem)
          } else {
            historyOrders[i].bar.push(curItem)
          }
        }
        var zeroTicket = historyOrders[i].tickets[0]
        var mmdt = Moment(zeroTicket.session_date_time)
        historyOrders[i].dateStr = mmdt.format('DD.MM.YYYY')
        historyOrders[i].timeStr = mmdt.format('HH:mm')
        historyOrders[i].film = zeroTicket.film
        historyOrders[i].screen_name = zeroTicket.screen_name
        historyOrders[i].isOpen = false
        state.historyOrders.push(historyOrders[i])
      }
      if (historyOrders.length < 20) {
        state.noMoreOperations = true
      } else {
        state.orderHistoryOffset += 20
      }
    },
    // Очистить историю заказов
    emptyHistoryOrders: function (state) {
      state.historyOrders = []
      state.orderHistoryOffset = 0
      state.noMoreOperations = false
    },
    // Задать историю фильмов
    setHistoryFilms: function (state, historyFilms) {
      for (var i in historyFilms) {
        state.historyFilms[i] = historyFilms[i]
      }
    },
    setHistoryItems: function (state, historyItems) {
      for (var i in historyItems) {
        state.historyItems[i] = historyItems[i]
      }
    },
    setBadges: function (state, badges) {
      state.badges = badges
    },
    setOffers: function (state, offers) {
      state.offers = offers.offers
    },
    openNextLvlRequirements: function (state) {
      state.nextLvlRequirementsOpen = true
    },
    closeNextLvlRequirements: function (state) {
      state.nextLvlRequirementsOpen = false
    },
    openFillProfile: function (state) {
      state.fillProfileOpen = true
    },
    closeFillProfile: function (state) {
      state.fillProfileOpen = false
    },
    // задать бейдж для показа в попапе
    setCurrentBadge: function (state, badge) {
      state.currentBadge = badge
    },
    resetCurrentBadge: function (state) {
      state.currentBadge = null
    },
    setFriendsLevels: function (state, levels) {
      state.friendsLevels = levels
    }
  },
  actions: {
    // запросить и сохранить инфо о пользователе
    getUser: function (context, callback) {
      Vue.http.post('/getuserdata', {details: ['contacts', 'personal', 'stuff', 'favorites', 'family', 'languages', 'cards', 'balance']}).then(response => {
        var user = response.body
        context.commit('setUser', user)
        if (callback) {
          callback()
        }
      })
    },
    getDicts: function (context, callback) {
      Vue.http.post('/getdict', {dictionary: ['cities', 'family_role', 'marital_status', 'social_status', 'cinemas', 'levels', 'recognition']}).then(response => {
        var dicts = response.body
        context.commit('setDicts', dicts)
        if (callback) {
          callback()
        }
      })
    },
    getCurrentOrders: function (context, callback) {
      Vue.http.get('/currentorder').then(response => {
        var currentOrders = response.body.current
        var currentFilms = response.body.films
        var currentItems = response.body.items
        context.commit('setCurrentOrders', currentOrders)
        context.commit('setCurrentFilms', currentFilms)
        context.commit('setCurrentItems', currentItems)
        if (callback) {
          callback()
        }
      })
    },
    getHistoryOrders: function (context, initial, callback) {
      if (initial) {
        context.commit('emptyHistoryOrders')
      }
      Vue.http.post('/orderhistory', {offset: context.state.orderHistoryOffset, limit: 20}).then(response => {
        var historyOrders = response.body.current
        var historyFilms = response.body.films
        var historyItems = response.body.items
        context.commit('setHistoryOrders', historyOrders)
        context.commit('setHistoryFilms', historyFilms)
        context.commit('setHistoryItems', historyItems)
        if (callback) {
          callback()
        }
      })
    },
    getBadges: function (context, callback) {
      Vue.http.get('/badges').then(response => {
        var badges = response.body
        context.commit('setBadges', badges)
        if (callback) {
          callback()
        }
      })
    },
    getFriendsLevels: function (context, callback) {
      Vue.http.get('/api/levels').then(response => {
        var levels = response.body
        context.commit('setFriendsLevels', levels)
      })
      if (callback) {
        callback()
      }
    },
    getOffers: function (context, callback) {
      Vue.http.get('/offers').then(response => {
        var badges = response.body
        context.commit('setOffers', badges)
        if (callback) {
          callback()
        }
      })
    }
  },
  getters: {
    dicts: (state, getters) => () => {
      var retdicts = {}
      var lang = state.uLang
      for (var field in state.dicts) {
        if (state.dicts[field][lang] && state.dicts[field][lang].length !== 0) {
          retdicts[field] = state.dicts[field][lang]
        } else {
          retdicts[field] = state.dicts[field]['def']
        }
      }
      // чтобы не крутить каждый раз цикл, переворачиваем массив КТ в объект с ключом внутренний Виста ИД
      retdicts.cinemasById = {}
      var cinemasArr = retdicts['cinemas'] || []
      for (var i = 0; i < cinemasArr.length; i++) {
        var curCinema = cinemasArr[i]
        retdicts.cinemasById[curCinema.vista_internal_id] = Object.assign({}, curCinema)
      }
      // Костыль если по АПИ не пришла тестовая Лавина
      if (!retdicts.cinemasById[10117]) {
        retdicts.cinemasById[10117] = Object.assign({}, retdicts.cinemasById[117])
      }
      // Также переворачиваем города
      retdicts.citiesById = {}
      var citiesArr = retdicts['cities'] || []
      for (i = 0; i < citiesArr.length; i++) {
        var curCity = citiesArr[i]
        retdicts.citiesById[curCity.id] = Object.assign({}, curCity)
      }
      // И еще переворачиваем левелы
      retdicts.levelsById = {}
      var levelsArr = retdicts['levels'] || []
      for (i = 0; i < levelsArr.length; i++) {
        var curLevel = levelsArr[i]
        retdicts.levelsById[curLevel.id] = Object.assign({}, curLevel)
      }
      return retdicts
    },
    badges: (state, getters) => () => {
      var retbadges = {}
      var lang = state.uLang
      for (var cat in state.badges) {
        var curcat = state.badges[cat]
        if (curcat[lang] && curcat[lang].length !== 0) {
          retbadges[cat] = curcat[lang]
        } else {
          retbadges[cat] = curcat['def']
        }
      }
      // console.log('RETBADGES', retbadges)
      return retbadges
    },
    offers: (state, getters) => () => {
      var retoffers = []
      var lang = state.uLang
      var initialOffers = state.offers
      if (initialOffers[lang] && initialOffers[lang].length !== 0) {
        retoffers = initialOffers[lang]
      } else {
        retoffers = initialOffers['def']
      }
      return retoffers
    },
    friendsLevels: (state, getters) => () => {
      var retFLevels = []
      var lang = state.uLang
      var initialFLevels = state.friendsLevels
      if (initialFLevels[lang] && initialFLevels[lang].length !== 0) {
        retFLevels = initialFLevels[lang]
      } else {
        retFLevels = initialFLevels['def']
      }
      return retFLevels
    },
    friendsLevelsByDictId: (state, getters) => () => {
      let levels = getters.friendsLevels()
      let levelsByDictId = {}
      for (let subscription of levels) {
        for (let level of subscription.levels) {
          levelsByDictId[level.dict_id] = level
        }
      }
      return levelsByDictId
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js